export default "__VITE_ASSET__CUa$2r2E__"